<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import axios from "axios";
import BulkSms from "@/components/reservation/BulkSms.vue";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "lessons",
  data() {
    return {
      type: this.$route.params.type,
      gradeSlug: this.$route.params.gradeSlug,
      dragIndex: null,
      lesson: null,
      lessons: [],
      branch: null,
      branches: [],
      unit: null,
      units: [],
    };
  },
  components: {
    BulkSms,
    Breadcrumb,
    Dropdown
  },
  computed: {
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: this.typeLabel, path: `/${this.type}/${this.gradeSlug}` },
      ];
    },
    typeLabel() {
      switch (this.type) {
        case 'branch':
          return 'الفروع';
        case 'unit':
          return 'الوحدات';
        case 'lesson':
          return 'الدروس';
        default:
          return '';
      }
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() {
      return this.resolvedGrade?.id ?? null;
    },
    typeNumber() {
      switch (this.type) {
        case 'branch':
          return 1;
        case 'unit':
          return 2;
        case 'lesson':
          return 3;
        default:
          return null;
      }
    }
  },
  methods: {
    fetchBranchTable() {
      const params = {
        type: this.typeNumber,
        academic_year_id: this.gradeId
      };
      if (this.unit && this.typeNumber === 3) {
        params.parent_id = this.unit.id;
      }
      if (this.branch && this.typeNumber === 2) {
        params.parent_id = this.branch.id;
      }

      axios
          .get('/lessons', { params })
          .then((response) => {
            this.lessons = response.data.data;
            // this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.lessons = [];
          });
    },
    deleteLesson(lesson_id) {
      Swal.fire({
        title: "هل تريد الحذف ؟",
        text: "سيتم الحذف نهائيا",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .delete(`lessons/${lesson_id}`)
              .then(({ data }) => {
                if (data.status == true) {
                  Swal.fire("تم الحذف بنجاح", "", "success");
                  this.lessons = this.lessons.filter(r => r.id !== lesson_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },

    async toggleHide(lesson) {
      const newHide = lesson.hide ? 0 : 1;
      try {
        await axios.post('lessons/hide', {
          lesson_id: lesson.id,
          hide: newHide
        });
        lesson.hide = newHide;
      } catch (e) {
        // handle error (optional)
      }
    },

    fetchBranch() {
      axios
          .get(`/lessons?type=1&academic_year_id=${this.gradeId}`)
          .then((response) => {
            this.branches = response.data.data;
          })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch.id;
      axios
          .get(`/lessons?type=2&academic_year_id=${this.gradeId}&parent_id=${branchId}`)
          .then((response) => {
            this.units = response.data.data;
          })
          .catch(() => {});
    },

    onDragStart(index) {
      this.dragIndex = index;
    },
    async onDrop(targetIndex) {
      if (this.dragIndex === null || this.dragIndex === targetIndex) return;
      const moved = this.lessons.splice(this.dragIndex, 1)[0];
      this.lessons.splice(targetIndex, 0, moved);
      // Send only the moved lesson
      await axios.post('lessons/reorder', {
        lesson_id: moved.id,
        order: targetIndex + 1
      });
      this.dragIndex = null;
    },

    customLabelBranch(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
    customLabelUnit(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
    customLabelLesson(option) {
      return option ? `${option.title} (${option.description})` : '';
    },
  },
  async mounted() {
    if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
    if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    this.fetchBranchTable();
    if (this.typeNumber === 2 || this.typeNumber === 3) {
      this.fetchBranch();
    }
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <div class="row d-flex align-items-center gap-4 w-75">
          <h4 class="mb-0 col-lg-2 col-12">{{ typeLabel }}</h4>
          <div class="row d-flex gap-lg-0 gap-2 col-lg-10 col-12 mb-lg-0 mb-2">
            <div class="col-lg-4 col-md-6 col-12" v-if="typeNumber === 2">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-full md:w-14rem" @update:model-value="fetchBranchTable" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12" v-if="typeNumber === 3">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-full md:w-14rem" @update:model-value="fetchUnits" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12" v-if="typeNumber === 3">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحده" class="w-full md:w-14rem" @update:model-value="fetchBranchTable" />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <router-link :to="`/${this.type}/${this.gradeSlug}/add`" class="btn PrimaryButton">إضافة {{ typeLabel }}</router-link>
        </div>
      </div>
    </div>
    <div class="row reservation-table">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
<!--                <th scope="col">الصورة</th>-->
                <th scope="col">العنوان</th>
                <th scope="col">الوصف</th>
                <th scope="col">الفرع الرئيسي</th>
                <th scope="col">النوع</th>
                <th scope="col">الحالة</th>
                <th scope="col">التحكم</th>
              </tr>
            </thead>
            <tbody>
              <tr
                  v-for="(lesson, index) in lessons"
                  :key="lesson.id"
                  draggable="true"
                  @dragstart="onDragStart(index)"
                  @dragover.prevent
                  @drop="onDrop(index)"
                  style="cursor: move;"
                >
                <td data-label="ID">{{ index + 1 }}</td>
<!--                <td data-label="الصورة">-->
<!--                  <img v-if="lesson.image" :src="lesson.image" alt="Lesson Image" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;" />-->
<!--                  <span v-else>-&#45;&#45; </span>-->
<!--                </td>-->
                <td data-label="الاسم">{{ lesson.title }}</td>
                <td data-label="الوصف">{{ lesson.description }}</td>
                <td data-label="الفرع الرئيسي">{{ lesson.parent ? lesson.parent.title : '---' }}</td>
                <td data-label="النوع">
                  <span v-if="lesson.type === 1">فرع</span>
                  <span v-else-if="lesson.type === 2">وحده</span>
                  <span v-else-if="lesson.type === 3">درس</span>
                </td>
                <td data-label="الحالة">{{ lesson.hide ? "مخفي" : "ظاهر" }}</td>
                <td data-label="التحكم">
                  <router-link class="btn btn-primary text-white mx-1"
                               :tooltip="'تعديل'"
                               flow="up"
                               :to="`/${type}/${gradeSlug}/edit/${lesson.id}`">
                    <i class="pi pi-pencil"></i>
                  </router-link>
                  <button
                      :class="lesson.hide ? 'btn btn-success' : 'btn btn-warning'"
                      @click="toggleHide(lesson)"
                      :tooltip="lesson.hide ? 'إظهار' : 'إخفاء'"
                      flow="up"
                  >
                    <i :class="lesson.hide ? 'pi pi-eye' : 'pi pi-eye-slash'"></i>
                  </button>
                  <button class="btn btn-danger text-white mx-1"
                          type="button"
                          :tooltip="`حذف`"
                          flow="up"
                          @click="deleteLesson(lesson.id)">
                    <i class="pi pi-trash"></i>
                  </button>
                </td>
              </tr>
              <tr v-if="lessons.length === 0">
                <td colspan="8" class="text-center">لا يوجد بيانات</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>